import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
// ******************************* Dark Feature Toggle Mechanism ******************************* //
// useFeatureToggles: hook that checks if a user belongs to a Dark Feature Audience
// ********************************************************************************************* //

import { useState, useEffect } from "react";
function useFeatureToggles(feature) {
  var _useState = useState(false),
    featureStatus = _useState[0],
    setFeatureStatus = _useState[1];
  var checkAdobeTargetOffers = function checkAdobeTargetOffers() {
    return new Promise(function (resolve, reject) {
      var verdict = false;
      window.adobe.target.getOffer({
        mbox: feature,
        success: function success(offers) {
          if (offers && offers.length > 0) {
            if (offers[0].content[0].status === "ON") verdict = true;
          } else {
            console.log("[Adobe Target]: featureToggles: No active offers (experiments) found.");
          }
          resolve(verdict);
        },
        error: function error(status, _error) {
          console.error("[Adobe Target]: featureToggles: Error fetching offers:", status, _error);
          reject(_error);
        }
      });
    });
  };
  var initFetchAdobeOffers = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window, _window$adobe;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
            case 1:
              if (!(typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$adobe = _window.adobe) === null || _window$adobe === void 0 ? void 0 : _window$adobe.target) === "undefined")) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 250);
              });
            case 4:
              _context.next = 1;
              break;
            case 6:
              _context.t0 = setFeatureStatus;
              _context.next = 9;
              return checkAdobeTargetOffers(feature);
            case 9:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t2 = _context["catch"](0);
              console.error(" [DarkEntitlement]: Error fetching feature status:", _context.t2);
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));
    return function initFetchAdobeOffers() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // Important: Dont change this. useEffect with async causes issues here
    initFetchAdobeOffers();
  }, []);
  return featureStatus;
}
export default useFeatureToggles;